(() => {
  const initialized = new WeakSet();

  function initProductZoom() {
    const images = document.querySelectorAll('.image-magnify-hover');

    console.log('Zoom lateral:', images.length, 'imágenes encontradas');

    images.forEach((image) => {
      if (initialized.has(image)) return;

      initialized.add(image);

      let zoomPane = null;

      image.addEventListener('mouseenter', () => {
        const rect = image.getBoundingClientRect();

        zoomPane = document.createElement('div');
        zoomPane.className = 'custom-product-zoom';

        const imageUrl = image.currentSrc || image.src;

        zoomPane.style.backgroundImage = `url("${imageUrl}")`;

        // Tamaño del zoom
        const zoomWidth = Math.min(rect.width, 500);
        const zoomHeight = Math.min(rect.height, 500);

        // Intentamos colocarlo a la derecha
        let left = rect.right + 24;

        // Si no cabe a la derecha, lo colocamos a la izquierda
        if (left + zoomWidth > window.innerWidth - 20) {
          left = rect.left - zoomWidth - 24;
        }

        // Si tampoco cabe a la izquierda, centramos
        if (left < 20) {
          left = 20;
        }

        let top = rect.top;

        // Evitar que se salga por abajo
        if (top + zoomHeight > window.innerHeight - 20) {
          top = window.innerHeight - zoomHeight - 20;
        }

        if (top < 20) {
          top = 20;
        }

        zoomPane.style.width = `${zoomWidth}px`;
        zoomPane.style.height = `${zoomHeight}px`;
        zoomPane.style.left = `${left}px`;
        zoomPane.style.top = `${top}px`;

        document.body.appendChild(zoomPane);

        updateZoom(image, zoomPane, null);
      });

      image.addEventListener('mousemove', (event) => {
        if (!zoomPane) return;

        updateZoom(image, zoomPane, event);

        console.log(
          'MOVE',
          event.clientX,
          event.clientY
        )
      });

      image.addEventListener('mouseleave', () => {
        if (zoomPane) {
          zoomPane.remove();
          zoomPane = null;
        }
      });
    });
  }

  function updateZoom(image, zoomPane, event) {
    const rect = image.getBoundingClientRect();

    let x = 50;
    let y = 50;

    if (event) {
      x = ((event.clientX - rect.left) / rect.width) * 100;
      y = ((event.clientY - rect.top) / rect.height) * 100;
    }

    zoomPane.style.backgroundPosition = `${x}% ${y}%`;
  }

  // Carga inicial
  initProductZoom();

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', () => {
    initProductZoom();
  });

  // Por si Dawn actualiza/reemplaza la galería dinámicamente
  const observer = new MutationObserver(() => {
    initProductZoom();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();